function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.4475 10.7286H20.9298L23.9764 13.7813L23.0667 14.691L20.014 11.6444V11.1621L19.8492 10.9912C19.1532 11.5895 18.2496 11.9497 17.2666 11.9497C15.0748 11.9497 13.2981 10.173 13.2981 7.9812C13.2981 5.78936 15.0748 4.0127 17.2666 4.0127C19.4584 4.0127 21.2351 5.78936 21.2351 7.9812C21.2351 8.96417 20.8749 9.86776 20.2765 10.5638L20.4475 10.7286ZM14.5192 7.9812C14.5192 9.50144 15.7463 10.7286 17.2666 10.7286C18.7868 10.7286 20.014 9.50144 20.014 7.9812C20.014 6.46096 18.7868 5.23377 17.2666 5.23377C15.7463 5.23377 14.5192 6.46096 14.5192 7.9812Z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6631 4.58323C12.285 4.53734 11.9001 4.51372 11.5098 4.51372C6.27304 4.51372 2.02295 8.76382 2.02295 14.0005C2.02295 19.2373 6.27304 23.4873 11.5098 23.4873C16.264 23.4873 20.205 19.9844 20.8909 15.4203C20.8909 15.4203 19.0992 13.4817 19.081 13.4817C19.093 13.6529 19.0992 13.8259 19.0992 14.0005C19.0992 18.1842 15.6934 21.59 11.5098 21.59C7.32608 21.59 3.92031 18.1842 3.92031 14.0005C3.92031 13.7254 3.93928 13.4503 3.96775 13.1847C6.20663 12.1886 7.98067 10.3576 8.91037 8.09025C9.80409 9.3543 10.9985 10.3896 12.3893 11.0919C11.8322 10.2069 11.5099 9.15912 11.5099 8.03607C11.5099 6.74005 11.9391 5.54431 12.6631 4.58323Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.47786 14.9492C7.47786 14.2946 8.00913 13.7634 8.66371 13.7634C9.3183 13.7634 9.84957 14.2946 9.84957 14.9492C9.84957 15.6038 9.3183 16.1351 8.66371 16.1351C8.00913 16.1351 7.47786 15.6038 7.47786 14.9492Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3558 13.7634C13.7012 13.7634 13.1699 14.2946 13.1699 14.9492C13.1699 15.6038 13.7012 16.1351 14.3558 16.1351C15.0104 16.1351 15.5417 15.6038 15.5417 14.9492C15.5417 14.2946 15.0104 13.7634 14.3558 13.7634Z",
  fill: "currentColor"
});

function SvgResearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "static/2.3.2/media/research.b2be3fef.svg";
export { SvgResearch as ReactComponent };